export default {
    getBreadcrumbList: state => {
        return state.breadcrumbList;
    },
    getActivet: state => {
        return state.defaultActive;
    },
    showPackage: state =>{
        return state.isShowPackage;
    },
    isHome: state =>{
        return state.isHome;
    },
    showPrice: state => {
        return state.isShowPrice
    }
  }



// WEBPACK FOOTER //
// ./src/store/getters/getters.js